// extracted by mini-css-extract-plugin
export default {"productGallery":"YM-z","inQuickShop":"ZM-z"};